import { footer_list } from '../lists/footer_list';
import '../style/Footer.css'

export function Footer() {
    return(
        <>
        <div className='footer_container'>
            {footer_list.map((item,index) => {
                return(
                    <div key={index} className='footer_box'>
                        <div className='foot_title'>{item.title}</div>
                        {item.info.map((infoItem,infoIndex) => {
                            return(
                                <div key={infoIndex} className='foot_info'>{infoItem}</div>
                            )
                        })}
                    </div>
                )
            })}
        </div>
        </>
    );

}